<script setup>
import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import DealsCard from '../DealsCard/DealsCard.vue';

defineProps({
  title: { type: String, default: '' },
  subtitle: { type: String, default: '' },
  showButton: { type: Boolean, default: true },
  buttonLabel: { type: String, default: '' },
});

const emit = defineEmits(['create']);

const onClick = () => {
  emit('create');
};

// Sample data for empty state preview
const sampleDeals = [
  {
    id: 1,
    title: 'Enterprise Software License',
    value: 50000,
    stage: 'negotiation',
    probability: 75,
    companyName: 'Acme Corporation',
    userName: 'John Smith',
    updatedAt: new Date().toISOString(),
  },
  {
    id: 2,
    title: 'Consulting Services Q2',
    value: 25000,
    stage: 'proposal',
    probability: 50,
    companyName: 'TechStart Inc.',
    userName: 'Sarah Johnson',
    updatedAt: new Date(Date.now() - 86400000).toISOString(),
  },
  {
    id: 3,
    title: 'Annual Support Contract',
    value: 120000,
    stage: 'closed_won',
    probability: 100,
    companyName: 'Global Services Ltd.',
    userName: 'Mike Wilson',
    updatedAt: new Date(Date.now() - 172800000).toISOString(),
  },
];
</script>

<template>
  <EmptyStateLayout :title="title" :subtitle="subtitle">
    <template #empty-state-item>
      <div class="grid grid-cols-1 gap-4 p-px overflow-hidden">
        <DealsCard
          v-for="deal in sampleDeals"
          :key="deal.id"
          :id="deal.id"
          :title="deal.title"
          :value="deal.value"
          :stage="deal.stage"
          :probability="deal.probability"
          :company-name="deal.companyName"
          :user-name="deal.userName"
          :updated-at="deal.updatedAt"
        />
      </div>
    </template>
    <template #actions>
      <div v-if="showButton">
        <Button :label="buttonLabel" icon="i-lucide-plus" @click="onClick" />
      </div>
    </template>
  </EmptyStateLayout>
</template>
